import React, { useEffect, useState } from "react";
import { CSVDownload, CSVLink } from "react-csv";

const CSVDownloader = ({ headers, data, filename, ...props }) => {
  return (
    <React.Fragment>
      <CSVLink
        headers={headers}
        data={data}
        filename={`${filename}.csv` || "report.csv"}
        style={{ textDecoration: "none" }}
        target="_blank"
      >
        <div className="f10-400" align="center">
          <img
            src={require("../../../assets/images/iconButton/downloadbtn.svg")}
            width={props.sortImgWidth ? "70px" : "80px"}
            alt="icon"
            title="Download"
          />
        </div>
      </CSVLink>
    </React.Fragment>
  );
};

export default CSVDownloader;
